import { render, staticRenderFns } from "./clientNotes.vue?vue&type=template&id=e726203c&scoped=true&"
import script from "./clientNotes.vue?vue&type=script&lang=js&"
export * from "./clientNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e726203c",
  null
  
)

export default component.exports